module.exports = __webpack_public_path__ + "media/assets/images/category/Dances@2x-b08b8e01b68eb23dcdcc750d56e5989e.png";